import React from 'react'

import { Modal } from 'react-bootstrap'

export default class formInput extends React.Component {

    render() {
        const { changeHandler, saveHandler, Model, cancelHandler, showModal, Errors, mode} = this.props

        return (
            <div class="mb-10">

                <Modal show={showModal} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{mode} Spesialis</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <div class="mb-3">
                            <label for="code" class="form-label">Name*</label>
                            <input type="code" class="form-control" id="name" value={Model.name} onChange={changeHandler("name")}></input>
                            <span className="error" style={{color:"red", fontStyle:"italic"}}>{Errors["name"]}</span>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="cancel" class="btn btn-warning" onClick={cancelHandler}>Batal</button>
                        <button type="button" class="btn btn-primary" onClick={saveHandler}>Simpan</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}